/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Type_LabelInputs */

const en_job_form_type_label = /** @type {(inputs: Job_Form_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment Type`)
};

const de_job_form_type_label = /** @type {(inputs: Job_Form_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art der Anstellung`)
};

/**
* | output |
* | --- |
* | "Employment Type" |
*
* @param {Job_Form_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_type_label = /** @type {((inputs?: Job_Form_Type_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Type_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_type_label(inputs)
	return en_job_form_type_label(inputs)
});